<template>
  <div>
    <HeaderComponent :menu-id="5"></HeaderComponent>
    <div style="background-color: #FFFFFF; position: relative;">
      <div class="peifu-container" style="width: 1200px;">
        <!-- 标题 -->
        <div class="title-ty" style="padding-bottom: 50px;">
          <div class="title-ty-y">SHUISHI GRADING</div>
          <div class="title-ty-z"><span>水石评级</span>如何送评</div>
        </div>
        <div class="fangshi-list">
          <div class="fangshi-item" style="width: 560px;">
            <div class="fangshi-item-1">
              <img src="@/assets/icon/xiaochengxu.png" alt="">
              <div>方式一:通过"水石评级"小程序直接送评</div>
            </div>
            <div class="fangshi-item-2"><div></div></div>
            <div class="fangshi-item-3">微信搜索小程序“水石评级"，点击“在线送评"，填写相关内容，<br>即可完成送评，并可随时了解评级流程进度。</div>
            <img class="fangshi-item-img" src="@/assets/image/ma-1.png" alt="">
          </div>
          <div class="fangshi-item" style="width: 450px;">
            <div class="fangshi-item-1">
              <img src="@/assets/icon/kefu.png" alt="">
              <div>方式二:通过官方客服进行送评</div>
            </div>
            <div class="fangshi-item-2"><div></div></div>
            <div class="fangshi-item-3">您可与水石评级官方客服进行沟通，进行古钱币送评。</div>
            <img class="fangshi-item-img" style="width: 150px;" src="@/assets/image/kefu-ma.png" alt="">
          </div>
        </div>
      </div>
      <img src="@/assets/image/logo-shuiyin.png" alt=""
        style="width: 300px; position:absolute; bottom: 0px; left: 0px;" />
    </div>
    <FooterComponent></FooterComponent>
  </div>
</template>

<script>
import HeaderComponent from '@/components/HeaderComponent.vue'
import FooterComponent from '@/components/FooterComponent.vue'

export default {
  data() {
    return {
    }
  },
  methods: {
  },
  components: {
    HeaderComponent,
    FooterComponent
  },
  created() {
  },
}
</script>
<style lang="less" scoped>
.fangshi-list{
  display: flex;
  justify-content: space-between;
  padding: 30px 20px;
  .fangshi-item-1{
    display: flex;
    align-items: center;
    div{
      font-size: 27px;
      font-weight: bold;
      letter-spacing: 2px;
    }
    img{
      width: 35px;
      height: 35px;
      margin-right: 10px;
    }
  }
  .fangshi-item-2{
    background-color: #F4F5F9;
    height: 1px;
    margin: 10px 0 20px;
    div{
      background-color: #DFB564;
      width: 60px;
      height: 1px;
    }
  }
  .fangshi-item-3{
    line-height: 30px;
  }
  .fangshi-item-img{
    width: 500px;
    margin: 30px auto;
  }
}
</style>